import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import CheckIcon from '@mui/icons-material/Check';

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {checkIfFeatureDisabled} from "../../lookFunctions";

const LookListFeatureCheckmark = (props) => {

  const {lookFeature, lookActiveCategory, lookActiveFeature, isEmpty} = props;

  if (!lookActiveCategory || isEmpty || !lookActiveFeature) {
    return null
  }

  if (lookFeature.getSplittedFeatureName() !== lookActiveFeature.getSplittedFeatureName()) {
    return null
  }

  const parent = lookFeature.getParent();
  const alreadyDisabled = checkIfFeatureDisabled(lookFeature, parent, true);

  if (alreadyDisabled) {
    return null
  }

  return (
    <div className="lm-feature__checkmark">
      <CheckIcon fontSize="small"/>
    </div>
  )
};

LookListFeatureCheckmark.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
  isEmpty: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;
  return {
    lookActiveFeature,
    lookActiveCategory,
    canvasCount
  };
};

export default connect(mapStateToProps)(LookListFeatureCheckmark)
